const InputErrorClass = ({ errors, name }: { errors: any, name: string }) => {
  return errors[name] ? 'form-control is-invalid' : 'form-control';
}

export default InputErrorClass;



// WEBPACK FOOTER //
// ./src/components/Shared/InputErrorClass.ts